import { useMemo } from 'react';

import { type Claim } from '../../users/_api/request.type';
import { type CustomGroup } from './use-custom-groups';

export function useClaimsByModuleId({ claims }: { claims: Claim[] }) {
  return useMemo(() => {
    const map = new Map<string, Claim>();

    for (const claim of claims) {
      map.set(claim.module.id, claim);
    }

    return map;
  }, [claims]);
}

export function useAssignedModuleIds({ customGroups }: { customGroups: CustomGroup[] }) {
  return useMemo(() => new Set(customGroups.flatMap((group) => group.moduleIds)), [customGroups]);
}

export function useFilteredClaims({
  claims,
  assignedModuleIds,
  excludedModules,
  includedModules,
}: {
  claims: Claim[];
  assignedModuleIds: Set<string>;
  excludedModules?: string[];
  includedModules?: string[];
}) {
  return useMemo(() => {
    let filtered = claims;

    if (includedModules) {
      filtered = filtered.filter(({ module: { id } }) => includedModules.includes(id));
    } else if (excludedModules) {
      filtered = filtered.filter(({ module: { id } }) => !excludedModules.includes(id));
    }

    return filtered.filter(({ module: { id } }) => !assignedModuleIds.has(id));
  }, [claims, assignedModuleIds, excludedModules, includedModules]);
}
